import ClientParticles from "./ClientParticles"

export default function Particles() {
  return <ClientParticles />
}
